import { useNavigate } from 'react-router-dom';
import { AxiosResponse } from 'axios';
import { useGlobalConfigs } from 'hooks';
import { handleError } from 'utils/handleError';
import { AppError } from 'exceptions/AppError';
import { App } from 'antd';

export type THandleError = (error: AxiosResponse | AppError, displayErrorMsg?: boolean) => void;

const useHandleErrors = () => {
	const { storage } = useGlobalConfigs();
	const navigate = useNavigate();

	const { message } = App.useApp();

	return { handleError: handleError(storage, navigate, message) };
};

export { useHandleErrors };
